interface SplashScreenProps {
  icon?: string;
  title: string;
  subtitle?: string;
  hint?: string;
  onDone?: () => void;
}

export function SplashScreen({ icon = '🌅', title, subtitle, hint, onDone }: SplashScreenProps) {
  return (
    <div
      className={`welcome-back${onDone ? '' : ' welcome-back--steady'}`}
      onAnimationEnd={onDone ? (e) => { if (e.target === e.currentTarget) onDone(); } : undefined}
    >
      <p className="welcome-back-sun">{icon}</p>
      <h1 className="welcome-back-heading">{title}</h1>
      {subtitle && <p className="welcome-back-email">{subtitle}</p>}
      {hint && <p className="welcome-back-hint">{hint}</p>}
    </div>
  );
}
